import React from 'react';
import { calculateEffortCost, calculateProblemTotal } from '../utils/calculations';

const logoUrl =
  'https://media-manager-c.questera.ai/greta-media/116a3eb51ffbcf2931cfd2bd07e79bf6b5f522eb2cb1a99b910065fd25fbaf3eb1d96bb3349b02209ad422f53caeedc3/images/aW1hZ2UvcG5n/5a429034d28f17c08328ff943da9fd8a.png';

const formatCurrency = (value) =>
  value.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0
  });

const formatValue = (value) => {
  if (value === '' || value === null || value === undefined) {
    return '–';
  }

  return Number(value).toLocaleString('de-DE');
};

const PrintReport = ({ problems, settings }) => {
  const totalCost = problems.reduce(
    (sum, problem) => sum + calculateProblemTotal(problem, settings).cost,
    0
  );

  return (
    <div className="print-report">
      <header className="print-report-header">
        <img src={logoUrl} alt="moldtech Logo" />
        <h1>moldtech ROI Rechner</h1>
      </header>

      <section className="print-settings">
        <h2>Globale Annahmen</h2>
        <table>
          <thead>
            <tr>
              <th>Stundensatz</th>
              <th>Arbeitswochen / Jahr</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{formatCurrency(Number(settings.hourlyRate) || 0)}</td>
              <td>{formatValue(settings.weeksPerYear)}</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="print-problems">
        <h2>Analysierte Problemstellungen</h2>

        {problems.length === 0 ? (
          <p className="print-empty">Es wurden noch keine Problemstellungen erfasst.</p>
        ) : (
          problems.map((problem) => {
            const problemTotal = calculateProblemTotal(problem, settings).cost;

            return (
              <div className="print-problem" key={problem.id}>
                <h3>{problem.name.trim() || 'Ohne Namen'}</h3>

                <table>
                  <thead>
                    <tr>
                      <th>Tätigkeit</th>
                      <th>Häufigkeit</th>
                      <th>Zeitaufwand</th>
                      <th>Ergebnis / Jahr</th>
                    </tr>
                  </thead>
                  <tbody>
                    {problem.efforts.length === 0 ? (
                      <tr>
                        <td colSpan="4">Keine Aufwandsschritte erfasst.</td>
                      </tr>
                    ) : (
                      problem.efforts.map((effort) => (
                        <tr key={effort.id}>
                          <td>{effort.name.trim() || 'Ohne Bezeichnung'}</td>
                          <td>
                            {formatValue(effort.freq)} x pro{' '}
                            {effort.freqUnit === 'day'
                              ? 'Tag'
                              : effort.freqUnit === 'month'
                                ? 'Monat'
                                : effort.freqUnit === 'year'
                                  ? 'Jahr'
                                  : 'Woche'}
                          </td>
                          <td>
                            {formatValue(effort.time)}{' '}
                            {effort.timeUnit === 'hr' ? 'Std.' : 'Min.'}
                          </td>
                          <td className="print-result">
                            {formatCurrency(calculateEffortCost(effort, settings))}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="3">Jährlicher Verlust</td>
                      <td className="print-total">{formatCurrency(problemTotal)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            );
          })
        )}
      </section>

      <section className="print-overall">
        <span>Gesamtauswertung / Verlustkosten pro Jahr</span>
        <strong>{formatCurrency(totalCost)}</strong>
      </section>

      <footer className="print-report-footer">
        Haben Sie Interesse an einer Prozessanalyse in Ihrem Hause? Kontaktieren
        Sie uns gerne unter info@moldtech.de Der zuständige Ansprechpartner wird
        sich dann mit Ihnen in Verbindung setzen.
      </footer>
    </div>
  );
};

export default PrintReport;